import { css } from '@emotion/react';
import styled from '@emotion/styled';
import { TabletWidth } from '../../../../global.style';
import { MobileOrderSummaryHeight } from '../../../common/PaymentSummary/MobilePaymentSummary.style';
import { getColor } from '../../../common/UICommon';
import { ContentCol, TwoSidedLayout } from '../../../common/v2/TwoSidedLayout/TwoSidedLayout.style';

const layoutStyleWithPaymentSummary = css`
  @media (max-width: ${TabletWidth}px) {
    padding-top: ${MobileOrderSummaryHeight}px;
  }
`;

export const ContactDetailsTwoSidedLayout = styled(TwoSidedLayout)<{ showPaymentSummary: boolean }>`
  ${({ showPaymentSummary }) => showPaymentSummary && layoutStyleWithPaymentSummary};
`;

export const ContactDetailsPaymentSummaryCol = styled(ContentCol)`
  background-color: ${getColor('LIGHT_CREAM')};
  min-height: 100vh;

  @media (max-width: ${TabletWidth}px) {
    display: none;
  }
`;
